// Typy biura podawczego (kreator rejestracji przesyłek przychodzących).

import { EParcelDeliveryCategory } from "dto/Mailroom/IDispatchChart";

/** Poziom dostępu przesyłki w archiwum (odpowiednik BE ParcelAccess). */
export enum EParcelAccess {
  Public = 0,
  Protected = 1,
  Private = 2,
}

/** Pozycja słownika: rodzaj załącznika lub forma doręczenia. */
/** Rodzaj semantyczny typu załącznika (BE ParcelAttachmentKind): 0 inny, 1 umowa. */
export enum EParcelAttachmentKind {
  Other = 0,
  Contract = 1,
  /** Dokument księgowy (faktura / PEF / KSeF). */
  Invoice = 2,
}

export interface IParcelLookup {
  Id: number;
  Name: string;
  SortOrder: number;
  /** Systemowa (nieedytowalna) pozycja słownika. */
  IsSystem: boolean;
  /** Tylko typy załączników: załącznik rodzaju „umowa" zakłada wpis w rejestrze umów. */
  Kind?: EParcelAttachmentKind;
  /** Pozycja nadrzędna (jeden poziom, jak lista pomocnicza Magistratu) — tylko typy załączników. */
  ParentId?: number | null;
  /** Forma elektroniczna (e-mail / ePUAP / e-Doręczenia ...) — tylko dla form doręczenia. */
  IsElectronic?: boolean;
  /** Kategoria formy doręczenia (BE ParcelDeliveryCategory) — tylko dla form doręczenia. */
  Category?: EParcelDeliveryCategory | null;
  /** Opłata pocztowa (cennik listów) — tylko papierowe formy doręczenia. */
  Fee?: number | null;
}

export interface IRegistryOffice {
  Id: string;
  Name: string;
  Symbol?: string | null;
  IsDefault: boolean;
}

/** Rodzaj przesyłki obsługiwany przez skład (odpowiednik BE Core.Enums.ItemKind). */
export enum EParcelStoreKind {
  /** Przesyłki przychodzące (rejestrowane w biurze podawczym). */
  Parcel = 0x10,
  /** Przesyłki wychodzące. */
  OutgoingParcel = 0x1000,
}

/** Skład chronologiczny — nadaje sygnaturę wg NumberFormat (BE ParcelStore). */
export interface IParcelStore {
  Id: string;
  Name: string;
  /** Szablon sygnatury, np. „{0}/P/{1:yy}". */
  NumberFormat: string;
  Kind: EParcelStoreKind;
  IsElectronic: boolean;
  ContinuousForYear: boolean;
  ContinuousForUser: boolean;
  IsDefault: boolean;
  IsActive: boolean;
}

export interface IMailroomSettings {
  DefaultReceiverUserId?: string | null;
  DefaultRegistryOfficeId?: string | null;
  DefaultParcelStoreId?: string | null;
}

/** Odbiorca/dekretujący z /incomingParcel/init (BE ParcelReceiver). */
export interface IParcelReceiver {
  Id: string;
  Label: string;
  /** Klucz publiczny (IntermediatePublicKey) do zaszyfrowania klucza obiektu. */
  PublicKey: string;
  IsMe: boolean;
}
